import { type FC } from "react";

export const HTML: FC<{
  html: string | TrustedHTML;
  className?: string;
}> = ({ html, className }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
);
